import { render, staticRenderFns } from "./InvitationStatusBadge.vue?vue&type=template&id=da9ea262&"
import script from "./InvitationStatusBadge.vue?vue&type=script&lang=js&"
export * from "./InvitationStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports